import React from 'react'
import IMG from "./mongodb.png"
function MongoLogo() {
  return (
    <img src={IMG} style={{width:"200px",height:"150px" }} alt='Mongo'/>
  )
}

export default MongoLogo